import CoreDeviceConnectionState from "@gf-core/widgets/widgets/CoreDeviceConnectionState";
import { DeviceBase } from "@gf-core/widgets/types/device";
import { useDevice } from "../../hooks/useDevice";

interface Props {
  installationId: string;
  deviceId?: string;
}

export default function ConnectionStatePostfix({
  installationId,
  deviceId,
}: Props) {
  const { data } = useDevice(installationId, deviceId, true);
  const device = data?.model;
  return device ? (
    <CoreDeviceConnectionState device={device as DeviceBase} as="icon" />
  ) : null;
}
